import Onboarding from './container';

export default Onboarding;
